module.exports = __webpack_public_path__ + "img/icon_tjhby.97f307cf.png";